import { useState } from 'react';
import BikeViewer from '../components/viewer/BikeViewer';
import ConfigPanel from '../components/configurator/ConfigPanel';
import Features from '../components/features/Features';
import styles from '../App.module.css';

export default function ConfiguratorPage() {
    const [activeCategory, setActiveCategory] = useState('color');

    return (
        <>
            <div className={styles.configuratorContainer}>
                <BikeViewer activeCategory={activeCategory} />
                <ConfigPanel activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
            </div>
            <Features />
        </>
    );
}
